<template>
  <div>
    <answer-render ref="answer" :config="config">
    </answer-render>
  </div>
</template>

<script>
export default {
  name: 'InfoBoxAnswer',
  props: ['config'],
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/editor/InfoBox/InfoBoxAnswer.vue